import PropTypes from 'prop-types'
import React, { Component } from 'react'
import _ from 'lodash'
import SlideShow from '../SlideShow'
import BannerSlide from './BannerSlide'
import VideoModal from '../VideoModal'
import './styles.css'

class BannerSlideShow extends Component {
  constructor() {
    super()

    this.state = {
      videoShow: false,
      video: ''
    }
  }

  toggleVideo(video = '') {
    this.setState((prevState) => ({ videoShow: !prevState.videoShow, video }))
  }

  render() {
    const { banners, isMobile, isSecondary } = this.props
    const manyBanners = _.size(banners) > 1

    return (
      <div className={isSecondary ? 'BannerSlideShowSecondary' : 'BannerSlideShow'}>
        <SlideShow
          arrows={manyBanners}
          draggable={isMobile}
          dots={manyBanners}
          autoplay={!isMobile}
          // SPEC-074: a CTA slide may grow on a phone; size the list to the
          // slide on screen instead of the tallest one
          adaptiveHeight={Boolean(isMobile)}
        >
          {banners.map((banner) => (
            <div key={banner.id}>
              <BannerSlide
                {...banner}
                video={banner.video}
                displayVideo={() => { this.toggleVideo(banner.video) }}
              />
            </div>
          ))}
        </SlideShow>

        <VideoModal
          url={this.state.video}
          visible={this.state.videoShow}
          close={() => this.toggleVideo()}
        />
      </div>
    )
  }
}

export const bannerPropType = PropTypes.shape({
  asset: PropTypes.shape({
    original: PropTypes.string,
    default: PropTypes.string,
    mobile: PropTypes.string,
    mobilexs: PropTypes.string,
    normal: PropTypes.string
  }),
  countdownDate: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.number,
  link: PropTypes.string,
  orderDate: PropTypes.string,
  title: PropTypes.string,
  hasGradient: PropTypes.bool
})

BannerSlideShow.propTypes = {
  banners: PropTypes.arrayOf(bannerPropType),
  isMobile: PropTypes.bool,
  isSecondary: PropTypes.bool
}

BannerSlideShow.defaultProps = {
  banners: [],
  isMobile: false,
  isSecondary: false
}

export default BannerSlideShow
